<template>
  <QuestionPage :title="questionAnswerData.question">
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='lt-fyf-answer-transport-basic'
      :onSelect="chooseBasic"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='lt-fyf-answer-transport-medium'
      :onSelect="chooseMedium"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.C"
      class='lt-fyf-answer-transport-top'
      :onSelect="chooseTop"
    />
  </QuestionPage>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('transport')
    }
  },
  methods: {
    ...mapMutations([
      'selectTransportStatus',
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectTransportStatus(1);
      this.goToItem('transport');
    },
    chooseMedium: function () {
      this.selectTransportStatus(2);
      this.goToItem('transport');
    },
    chooseTop: function () {
      this.selectTransportStatus(3);
      this.goToItem('transport');
    }
  },
};
</script>

<style lang='scss'>
.lt-fyf-answer-transport-basic {
  background-image: url('../../assets/questions/transport-minimum.jpg');
}
.lt-fyf-answer-transport-medium {
  background-image: url('../../assets/questions/transport-moderate.jpg');
}
.lt-fyf-answer-transport-top {
  background-image: url('../../assets/questions/transport-comfortable.jpg');
}
</style>